/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --gap: var(--nve-ref-space-xs);
  --font-size: var(--nve-ref-font-size-200);
  --padding: var(--nve-ref-size-200) var(--nve-ref-size-300);
  --border: 0;
  --border-radius: var(--nve-ref-border-radius-md);
  --icon-size: var(--nve-ref-size-600);
  --icon-color: var(--color);
  --color: var(--nve-sys-text-emphasis-color);
  --background: var(--state-color-background);
  width: 100%;
}

[internal-host] {
  background: var(--background);
  font-size: var(--font-size);
  gap: var(--gap);
  color: var(--color);
  padding: var(--padding);
  border: var(--border);
  border-radius: var(--border-radius);
  display: flex;
  flex-direction: column;
  --_alert-color: var(--color);
  --_icon-color: var(--icon-color);
}

::slotted(nve-alert) {
  --color: var(--_alert-color);
  --icon-color: var(--_icon-color);
  --icon-size: var(--nve-ref-size-400);
  --min-height: var(--nve-ref-size-800);
  width: 100%;
  height: 100%;
}

:host([container='full']) {
  --border-radius: 0;
}

:host([prominence='emphasis']:not([color])) {
  --background: var(--nve-sys-support-color);
  --color: var(--nve-sys-text-white-color);
  --icon-color: var(--color);
}

:host([prominence='emphasis'][status='accent']:not([color])) {
  --background: var(--nve-sys-support-accent-color);
}

:host([prominence='emphasis'][status='success']:not([color])) {
  --background: var(--nve-sys-support-success-color);
}

:host([prominence='emphasis'][status='warning']:not([color])) {
  --background: var(--nve-sys-support-warning-color);
  --color: var(--nve-sys-text-black-color);
}

:host([prominence='emphasis'][status='danger']:not([color])) {
  --background: var(--nve-sys-support-danger-color);
}

:host([prominence='emphasis']) ::slotted(nve-alert) {
  --font-weight: var(--nve-ref-font-weight-regular);
}

:host(:not([prominence='emphasis'])) ::slotted(nve-alert) {
  --icon-color: var(--status-color) !important;
}

:host([status]) {
  --state-color-base: var(--status-color);
}

:host([color]) ::slotted(nve-alert) {
  --status-color: var(--state-color-base) !important;
}
